import { all, call, put, takeLatest } from 'redux-saga/effects'

import { deleteRequest, getRequest } from 'api/apiUtils'
import { IS_PRODUCTION } from 'utils/helperConfig'
import TwoFActionTypes from 'redux/2FA/2FA-types'
import AcquiringActionTypes from 'redux/acquiring/acquiring-types'
import AddressesActionTypes from 'redux/addresses/addresses-types'
import {
    failureDeleteAppNotification,
    failureFetchAppNotifications,
    fetchNotificationAlert as fetchNotificationAlertAction,
    finishErrorAlert,
    finishFetchAppNotifications,
    finishNotificationAlert,
    startErrorAlert,
    startInfoAlert,
    startNotificationAlert,
    startSuccessAlert,
    startWarningAlert,
    successDeleteAppNotification,
    successFetchAppNotifications,
} from 'redux/alert/alert-actions'
import BatchPaymentsActionTypes from 'redux/batchPayments/batchPayments-types'
import CardsActionTypes from 'redux/cards/cards-types'
import DigitalAssetkActionTypes from 'redux/digitalAssets/digitalAssets-types'
import LedgerActionTypes from 'redux/ledger/ledger-types'
import LimitedTokensActionTypes from 'redux/limitedTokens/limitedTokens-types'
import SettingsActionTypes from 'redux/settings/settings-types'
import TradingDeskActionTypesV2 from 'redux/tradingDeskV2/tradingDeskV2-types'
import UserActionTypes from 'redux/user/user-types'

import TransactionsActionTypes from '../transactions/transactions-types'

import AlertActionTypes from './alert-types'

function* failure({ payload: { errorMessage } }) {
    yield put(startErrorAlert(errorMessage))
}

export function* onFailure() {
    yield takeLatest(
        [
            CardsActionTypes.FAILURE_CARD_ORDER,
            CardsActionTypes.FAILURE_CARD_TOP_UP,
            CardsActionTypes.FAILURE_CARD_WITHDRAW,
            CardsActionTypes.FAILURE_CARD_FREEZE,
            CardsActionTypes.FAILURE_CARD_UNFREEZE,
            CardsActionTypes.FAILURE_CARD_ACTIVATION,
            CardsActionTypes.FAILURE_CARD_DEACTIVATE,
            CardsActionTypes.FAILURE_RECEIVE_PIN,
            CardsActionTypes.FAILURE_CARD_DETAILS,

            LedgerActionTypes.FAILURE_FEE_CALCULATOR,
            LedgerActionTypes.FAILURE_BANK_ACCOUNT_ORDER,
            LedgerActionTypes.FAILURE_TOP_UP_WITH_BANK_TRANSFER,
            LedgerActionTypes.FAILURE_GET_MAX_AMOUNT,
            LedgerActionTypes.FAILURE_LEDGER_TOP_UP_WITH_NO_CARD_DATA,

            LedgerActionTypes.FAILURE_BANK_ACCOUNT_INTERNAL_TRANSFER,
            LedgerActionTypes.FAILURE_BANK_ACCOUNT_TOP_UP_WITH_CURRENCY,
            LedgerActionTypes.FAILURE_BANK_ACCOUNT_WITHDRAW_WITH_CURRENCY,

            LedgerActionTypes.FAILURE_TRANSFER,

            LedgerActionTypes.FAILURE_EXCHANGE_All_ASSETS,

            LedgerActionTypes.FAILURE_TRANSFER_TO_BANK,
            LedgerActionTypes.FAILURE_TRANSFER_FROM_IBAN_TO_BANK,

            LedgerActionTypes.FAILURE_ORDER_CURRENCY,

            UserActionTypes.SIGN_UP_FAILURE,
            UserActionTypes.SIGN_IN_FAILURE,
            UserActionTypes.FAILURE_PASSWORD_RESET_REQUEST,

            UserActionTypes.FAILURE_TEMPORARY_PASSWORD_CHANGE,

            SettingsActionTypes.FAILURE_UPLOAD_DOCUMENTS,
            SettingsActionTypes.FAILURE_CHANGE_PASSWORD,

            TwoFActionTypes.FAILURE_CHANGE_2FA_AUTHENTICATION_TYPE,

            TwoFActionTypes.FAILURE_GOOGLE_AUTHENTICATION_SETUP,
            TwoFActionTypes.FAILURE_GOOGLE_AUTHENTICATION_VERIFY,
            TwoFActionTypes.FAILURE_FETCH_AUTHENTICATION_TYPES,

            SettingsActionTypes.FAILURE_NEW_SUPPORT_CONVERSATIONS,
            SettingsActionTypes.FAILURE_DOCUMENT_REQUEST_FORM,
            SettingsActionTypes.FAILURE_COMPANY_REGISTER_FORM,
            SettingsActionTypes.FAILURE_SUPPORT_CONVERSATIONS,

            TradingDeskActionTypesV2.FAILURE_ACCOUNT_DEPOSIT,
            TradingDeskActionTypesV2.FAILURE_ACCOUNT_WITHDRAW,
            TradingDeskActionTypesV2.FAILURE_ADD_ACCOUNT,
            TradingDeskActionTypesV2.FAILURE_EXCHANGE,
            TradingDeskActionTypesV2.FAILURE_MAX_FEES_V2,
            TradingDeskActionTypesV2.FAILURE_GET_EXCHANGE_FEE,

            SettingsActionTypes.FAILURE_SUBMIT_COMPANY_FORM_DOCUMENT,
            SettingsActionTypes.FAILURE_SERVICE_PLAN,

            LedgerActionTypes.FAILURE_PAY_NOW,

            LedgerActionTypes.FAILURE_SECURE_3D_CARD,

            TwoFActionTypes.FAILURE_2FA,

            UserActionTypes.FAILURE_ONBOARDING_FEE,

            DigitalAssetkActionTypes.FAILURE_ADD_DIGITAL_ASSET,
            DigitalAssetkActionTypes.FAILURE_SEND_DIGITAL_ASSETS_AMOUNT,

            DigitalAssetkActionTypes.FAILURE_TRANSFER_USDC_COIN,
            DigitalAssetkActionTypes.FAILURE_BUY_USDC_COIN_WITH_BANK,
            DigitalAssetkActionTypes.FAILURE_GET_DIGITAL_ASSET_WALLET_BY_ID,

            SettingsActionTypes.FAILURE_BUSINESS_REGISTRATION,

            LimitedTokensActionTypes.FAILURE_BUY_LIMITED_TOKENS,
            LimitedTokensActionTypes.FAILURE_TRANSFER_LIMITED_TOKENS,
            LimitedTokensActionTypes.FAILURE_WITHDRAW_LIMITED_TOKENS,
            LimitedTokensActionTypes.FAILURE_SELL_LIMITED_TOKENS,
            LimitedTokensActionTypes.FAILURE_GET_SELL_LIMITED_TOKENS_FEE,
            LimitedTokensActionTypes.FAILURE_GET_LIMITED_TOKEN_DETAILS,
            LimitedTokensActionTypes.FAILURE_GET_BUY_LIMITED_TOKENS_FEE,
            LimitedTokensActionTypes.FAILURE_FETCH_AVAILABLE_LIMITED_TOKENS,
            LimitedTokensActionTypes.FAILURE_FETCH_LIMITED_TOKEN_HOT_WALLET_FEE,
            LimitedTokensActionTypes.FAILURE_REDEEM_LIMITED_TOKENS,

            TransactionsActionTypes.ERROR_FAKE_DEPOSIT,
            TransactionsActionTypes.ERROR_CANCEL_TRANSACTION,
            TransactionsActionTypes.ERROR_COMPLETE_TRANSACTION,

            LedgerActionTypes.FAILURE_ORDER_MULTI_CURRENCY,

            UserActionTypes.FAILURE_EXTERNAL_ACCOUNT_LINK,

            SettingsActionTypes.FAILURE_USER_SETTINGS,

            SettingsActionTypes.FAILURE_COMPANIES_MEMBER,
            SettingsActionTypes.FAILURE_PUT_COMPANIES_MEMBER_GROUP,
            SettingsActionTypes.FAILURE_REMOVE_COMPANIES_MEMBER_GROUP,

            AcquiringActionTypes.FAILURE_GET_DEFAULT_CARD_ACQUIRING,
            AcquiringActionTypes.FAILURE_GET_ACCOUNTS_ACQUIRING,
            AcquiringActionTypes.FAILURE_ACQUIRING_TRANSFERS_DOWNLOAD,
            AcquiringActionTypes.FAILURE_CARD_ACQUIRING_MERCHANTS,
            AcquiringActionTypes.FAILURE_GET_CARD_ACQUIRING_SETTLEMENTS,
            AcquiringActionTypes.FAILURE_GET_CARD_ACQUIRING_CHARGES,
            AcquiringActionTypes.FAILURE_ACQUIRING_CREDENTIALS_REGENERATE,
            AcquiringActionTypes.FAILURE_ACQUIRING_CHARGES_DOWNLOAD,
            AcquiringActionTypes.FAILURE_SETTLEMENTS_CSV_DOWNLOAD,
            AcquiringActionTypes.FAILURE_SETTLEMENTS_PDF_DOWNLOAD,
            AcquiringActionTypes.FAILURE_SETTLEMENTS_PERIOD_SUMMARY_DOWNLOAD,

            AddressesActionTypes.FAILURE_BUY_ADDRESS_SUBSCRIPTION,
            AddressesActionTypes.FAILURE_CHANGE_SHIPPING_ADDRESS,
            AddressesActionTypes.FAILURE_VERIFY_PRIMARY_ADDRESS,

            SettingsActionTypes.FAILURE_DYNAMIC_FORM_SUBMIT,

            LedgerActionTypes.FAILURE_COUNTRIES_LIST,

            UserActionTypes.FAILURE_BUSINESS_REGISTRATION_SIGN_UP,

            LedgerActionTypes.FAILURE_LEDGER_TOP_UP_WITH_ONLINE_BANK,
            LedgerActionTypes.FAILURE_SECURE_3D_ONLINE_BANK,

            LedgerActionTypes.FAILURE_MERGED_FEE_CALCULATOR,

            UserActionTypes.FAILURE_PUT_PERSONAL_QUESTIONNAIRE,

            UserActionTypes.FAILURE_GET_COMPANIES_REGISTRATION_FEE,

            LedgerActionTypes.FAILURE_COMPANY_PAYMENT_CARD,
            LedgerActionTypes.FAILURE_SECURE_3D_COMPANY_CARD_PAYMENT,
            LedgerActionTypes.FAILURE_COMPANY_PAYMENT_ONLINE_BANKING,
            LedgerActionTypes.FAILURE_SECURE_3D_COMPANY_ONLINE_BANKING_PAYMENT,

            AcquiringActionTypes.FAILURE_PAYMENT_GATEWAY_MERCHANTS,

            SettingsActionTypes.FAILURE_UPLOAD_DOCUMENT_SOURCE_OF_FUNDS,

            LedgerActionTypes.FAILURE_TRANSLITERATION_TRANSFER_REFERENCE,

            BatchPaymentsActionTypes.FAILURE_IMPORT_BATCH_PAYMENT_FILE,
            BatchPaymentsActionTypes.FAILURE_EXECUTE_BATCH_PAYMENT_REQUESTS,
            BatchPaymentsActionTypes.FAILURE_CANCEL_BATCH_PAYMENT_REQUESTS,
            BatchPaymentsActionTypes.FAILURE_GET_BATCH_PAYMENT_STATUSES,
            BatchPaymentsActionTypes.FAILURE_GET_IMPORTED_BATCH_PAYMENTS,
            BatchPaymentsActionTypes.FAILURE_GET_BATCH_PAYMENT_REQUESTS,

            UserActionTypes.FAILURE_CHECK_EMAIL_AVAILABILITY,
        ],
        failure
    )
}

function* success({ payload: { successMessage } }) {
    yield put(startSuccessAlert(successMessage))
}

export function* onSuccess() {
    yield takeLatest([UserActionTypes.SUCCESS_PASSWORD_RESET_REQUEST], success)
}

function* info({ payload: data }) {
    yield put(startInfoAlert(data))
}

export function* onInfo() {
    yield takeLatest(
        [],

        info
    )
}

function* warning({ payload: data }) {
    yield put(startWarningAlert(data))
}

export function* onWarning() {
    yield takeLatest(
        [],

        warning
    )
}

function* fetchNotificationAlerts() {
    try {
        const { data } = yield getRequest('/identity/alerts')

        if (data && data.length) {
            yield put(startNotificationAlert({ pendingAlertsRequests: data }))
        }
        if (data && data.length === 0) {
            yield put(finishNotificationAlert())
        }
    } catch (err) {
        if (!IS_PRODUCTION) {
            console.log(err?.response?.data)
        }
    }
}

export function* onFetchNotificationAlerts() {
    yield takeLatest([AlertActionTypes.FETCH_NOTIFICATION_ALERT_DISPLAY, LedgerActionTypes.FINISH_PAY_NOW], fetchNotificationAlerts)
}

function* finishFailureAlert() {
    yield put(finishErrorAlert())
}

export function* onFinishAlert() {
    yield takeLatest(
        [UserActionTypes.SIGN_IN_FINISH],

        finishFailureAlert
    )
}

function* fetchData() {
    yield put(fetchNotificationAlertAction())
}

export function* onFetchData() {
    yield takeLatest([UserActionTypes.SIGN_IN_SUCCESS], fetchData)
}

function* fetchAppNotifications() {
    try {
        const { data } = yield getRequest('/identity/notifications')

        if (data && data.length) {
            yield put(successFetchAppNotifications(data))
        }
        if (data && data.length === 0) {
            yield put(finishFetchAppNotifications())
        }
    } catch (err) {
        yield put(failureFetchAppNotifications({ errorMessage: err?.response?.data?.errors }))
        if (!IS_PRODUCTION) {
            console.log(err?.response?.data)
        }
    }
}
export function* onFetchAppNotification() {
    yield takeLatest(AlertActionTypes.START_FETCH_APP_NOTIFICATIONS, fetchAppNotifications)
}

function* deleteAppNotification({ payload }) {
    try {
        yield deleteRequest(`/identity/notifications/${payload}`)
        yield put(successDeleteAppNotification())
    } catch (err) {
        yield put(failureDeleteAppNotification({ errorMessage: err?.response?.data?.errors }))
        if (!IS_PRODUCTION) {
            console.log(err?.response?.data)
        }
    }
}
export function* onDeleteAppNotification() {
    yield takeLatest(AlertActionTypes.START_DELETE_APP_NOTIFICATION, deleteAppNotification)
}

export function* alertSagas() {
    yield all([
        call(onFailure),
        call(onSuccess),
        call(onInfo),
        call(onWarning),
        call(onFinishAlert),
        call(onFetchData),
        call(onFetchNotificationAlerts),
        call(onFetchAppNotification),
        call(onDeleteAppNotification),
    ])
}
